module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Medium.75a3d593.woff2";